import { render, staticRenderFns } from "./temp.vue?vue&type=template&id=0598ffcc&scoped=true&"
var script = {}
import style0 from "./temp.vue?vue&type=style&index=0&id=0598ffcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0598ffcc",
  null
  
)

export default component.exports